import apiProvider from './provider';
import { 
  SHIPSY_DASHBOARD_AI,
  BI_AGENTS_TO_BE_USED,
  BI_GENERATE_METRICS,
  BI_GENERATE_FILTERS,
  BI_GENERATE_HAVING_FILTERS,
  BI_GENERATE_CHART_OPTIONS,
  BI_GENERATE_CUSTOM_METRICS,
  BI_GENERATE_CUSTOM_AGGREGATE_METRICS
} from './routes';
import { SHIPSY_DASHBOARD_AI_BASE_URL, SHIPSY_DASHBOARD_AI_ENV } from '../globals';
import { getAuthenticationHeaders } from './utils';
import { POST } from '@api/apiHandler';

export const getAiAnswer = async (query) => {

  const response = await POST(`${SHIPSY_DASHBOARD_AI_BASE_URL}${SHIPSY_DASHBOARD_AI}?env=${SHIPSY_DASHBOARD_AI_ENV}`, query);
  return response.data;
};

// BI Agent APIs
export const getAgentsToBeUsed = async (data) => {
  const response = await POST(`${SHIPSY_DASHBOARD_AI_BASE_URL}${BI_AGENTS_TO_BE_USED}`, data);
  return response.data;
};

export const generateMetrics = async (data) => {
  const response = await POST(`${SHIPSY_DASHBOARD_AI_BASE_URL}${BI_GENERATE_METRICS}`, data);
  return response.data;
};

export const generateFilters = async (data) => {
  const response = await POST(`${SHIPSY_DASHBOARD_AI_BASE_URL}${BI_GENERATE_FILTERS}`, data);
  return response.data;
};

export const generateHavingFilters = async (data) => {
  const response = await POST(`${SHIPSY_DASHBOARD_AI_BASE_URL}${BI_GENERATE_HAVING_FILTERS}`, data);
  return response.data;
};

export const generateChartOptions = async (data) => {
  const response = await POST(`${SHIPSY_DASHBOARD_AI_BASE_URL}${BI_GENERATE_CHART_OPTIONS}`, data);
  return response.data;
};

export const generateCustomMetrics = async (data) => {
  const response = await POST(`${SHIPSY_DASHBOARD_AI_BASE_URL}${BI_GENERATE_CUSTOM_METRICS}`, data);
  return response.data;
};

export const generateCustomAggregateMetrics = async (data) => {
  const response = await POST(`${SHIPSY_DASHBOARD_AI_BASE_URL}${BI_GENERATE_CUSTOM_AGGREGATE_METRICS}`, data);
  return response.data;
};